import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
const allInspectionIds = state => state.entities.inspection.allIds;
const inspectionById = state => state.entities.inspection.byId;
const formDataById = state => state.entities.formData.byId;
export const getCurrentPage = state => state.entities.reports.page;
export const getReportsPerPage = state => state.entities.reports.reportsPerPage;
export const getSortingTerm = state => state.entities.reports.sortingTerm;
export const getFilters = state => state.entities.reports.filters;
export const getSelections = state => state.entities.reports.selections;
export const getFilteredDataCount = state => (state.entities.inspection.metadata
  && state.entities.inspection.metadata.total);

const getSearch = state => state.entities.reports.search;

export const getUnfilteredData = state => allInspectionIds(state).map(
  id => inspectionById(state)[id]
)

const selectFilterProps = query => {
  let value = '';
  let field;
  let isSet = false;
  if (query !== undefined) {
    value = query.value !== undefined ? query.value : value;
    field = query.field !== undefined ? query.field : field;
    isSet = field !== undefined && field !== null && value !== undefined;
  }

  return {
    value,
    field,
    isSet,
  };
};

export const getFormDataFromPage = createSelector(
  [getUnfilteredData, formDataById], 
  (pageInspections, data) => {
    const ids = pageInspections.reduce(function(result, inspection) {
      if (inspection._id) {
        result.push(inspection._id);
      }
      return result;
    }, []);
    let formData = {}
    ids.forEach(formId => {
      formData[formId] = data[formId]
    });
    return formData;
  }
);

const getSortedData = createSelector([getSortingTerm, allInspectionIds, inspectionById], (sortingTerm, ids, data) => {
  if (!data) return null;
  const { column, direction } = sortingTerm;
  const inspections = ids.map(id => {
    let inspection = data[id];
    let value = inspection[column];
    if (value !== '' && !isNaN(value)) {
      inspection[column] = parseFloat(value);
    }
    return inspection;
  });
  const sortedData =
    direction === 'desc'
      ? inspections.sort((a, b) => (b[column] < a[column] ? -1 : 1))
      : inspections.sort((a, b) => (a[column] < b[column] ? -1 : 1));

  return sortedData;
});

export const getFilteredData = createSelector(
  [getFilters, getSortedData, getSearch],
  (visibilityFilters, reports, search) => {
    if (!reports) return [];
    let filteredArray = [...reports];
    if (visibilityFilters) {
      for (let filter of visibilityFilters) {
        const { value, field, isSet } = selectFilterProps(filter);
        filteredArray = filteredArray.filter((row, i) => {
          let show = false;

          if (isSet) {
            let fieldValue = row[field]; //getValue(row, field.value, getSourceValue, type);
            //Special case for createdBy object
            if (typeof fieldValue === 'object') {
              fieldValue = fieldValue.firstName + ' ' + fieldValue.lastName;
            }
            if ('min' in value) {
              show = fieldValue > value.min && fieldValue < value.max;
            } else {
              const valueString = String(value.value);
              const reverse = value.reverse;
              const fieldValueString = String(fieldValue);
              show = fieldValueString.indexOf(valueString) !== -1;
              show = show ? !reverse : reverse; //emulated XOR
            }
          } else {
            show = true; // If the query is not completed
          }

          if (!show) {
            return false; // We return false if one of all queries doesn't match
          }

          return show;
        });
      }
    }
    if (search != null && search !== '') {
      filteredArray = filteredArray.filter((row, i) => {
        const { status, ...rest } = row;

        return (
          JSON.stringify(rest)
            .toUpperCase()
            .indexOf(String(search).toUpperCase()) !== -1
        );
      });
    }

    return filteredArray;
  }
);

export const getFilteredDataPerPage = createSelector(
  [getFilteredData, getCurrentPage, getReportsPerPage],
  (data, page, perPage) => {
    return data.slice(page * perPage, page * perPage + perPage);
  }
);

export const getNextFilteredReportId = createCachedSelector(
  getFilteredData,
  (state, id) => id,
  (data, id) => {
    var index = data.findIndex(item => item._id === id);
    if (
      index < 0 ||
      index === data.length - 1
      // || data[index + 1].status !== 'completed'
    ) {
      return null;
    }

    return data[index + 1]._id;
  }
)((state, id) => id);

export const getPreviousFilteredReportId = createCachedSelector(
  getFilteredData,
  (state, id) => id,
  (data, id) => {
    var index = data.findIndex(item => item._id === id);
    if (
      index <= 0
      // || data[index - 1].status !== 'completed'
    ) {
      return null;
    }
    return data[index - 1]._id;
  }
)((state, id) => id);



// WEBPACK FOOTER //
// ./src/modules/reports/reports.selectors.js